import React, { FC } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

import { colors } from '../../dashboard/pool-graph';
import { PoolGraphVariant } from '../../dashboard/variables';

export const EmptyPositionGraph: FC = () => {
  const data = [
    { name: 'A', value: 6000 },
    { name: 'B', value: 400 },
    { name: 'B', value: 400 },
    { name: 'B', value: 400 },
  ];

  const activeIndex = -1;

  const variant = PoolGraphVariant.GRANTED;
  return (
    <ResponsiveContainer className={'opacity-50 blur-md'} height="100%" width="100%">
      <PieChart>
        <Pie cx="50%" cy="50%" data={data} dataKey="value" innerRadius="50%" outerRadius="100%">
          {data.map((_, index) => (
            <Cell
              fill={
                activeIndex === index
                  ? colors[variant].activeColors[index % colors[variant].activeColors.length]
                  : colors[variant].fillColors[index % colors[variant].fillColors.length]
              }
              fillOpacity={1}
              key={index}
              stroke={colors[variant].strokeColors[index % colors[variant].strokeColors.length]}
              style={{
                transition: 'all 0.5s ease, stroke 0.5s ease',
              }}
            />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};
